import React from 'react';
import Tile, { TileProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content/tile';
import Minicard, { MiniCard as MiniCardProps } from './mini-card';
import TextTile, { TextTileProps } from './text-tile';
import Title, { Title as TitleProps } from './title';
import {
  CAVA_CONTENT_LOOK,
  ContentLook,
} from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';

export interface EcoSectionProps {
  children?: React.ReactNode;

  miniCards: MiniCardProps[];
  titleInfo: TitleProps;
  tileInfo: TileProps;
  textTileInfo?: TextTileProps;
  look?: ContentLook;
}

const EcoSection: React.FC<EcoSectionProps> = ({
  miniCards,
  titleInfo,
  tileInfo,
  textTileInfo,
  look = CAVA_CONTENT_LOOK,
}) => {
  const miniCardsComp = () => {
    return miniCards?.map((miniCard, index) => {
      return <Minicard key={index} miniCard={miniCard} className={look.ecoMiniCardClassName} index={index} />;
    });
  };

  return (
    <>
      <section data-testid="eco-region">
        <div className="flex flex-col items-center">
          <Title title={titleInfo} titleClassName={look.ecoTitleClassName}></Title>
          <div
            className="flex flex-col items-end space-x-30 md:flex-row md:items-center"
            data-testid="eco-mini-card-list"
          >
            {miniCardsComp()}
          </div>
        </div>
        {tileInfo && (
          <Tile
            image={tileInfo?.image}
            title={tileInfo?.title}
            subtitle={tileInfo?.subtitle}
            ctaLabel={tileInfo?.ctaLabel}
            ctaReference={tileInfo?.ctaReference}
            className={look.ecoTitleTileClassName}
            titleFontFamily={look.tileTitleFontFamily}
            ctaFontFamily={look.tileCtaFontFamily}
            ctaClassName={look.tileCtaClassName}
            alignment="left"
          />
        )}
        {textTileInfo?.icon && (
          <TextTile
            icon={textTileInfo.icon}
            mainText={textTileInfo.mainText}
            ctaText={textTileInfo.ctaText!}
            resultsEco={textTileInfo.resultsEco}
            tileContent={textTileInfo.tileContent}
            ctaReference={textTileInfo.ctaReference}
            ctaClassName={look.ecoTextTileCtaClassName}
            titleFontFamily={look.ecoTextTileTitleFontFamily}
            titleClassName={look.ecoTextTileTitleClassName}
            tileTitleFontFamily={look.tileTitleFontFamily}
            tileCtaFontFamily={look.tileCtaFontFamily}
            tileCtaClassName={look.tileCtaClassName}
          />
        )}
      </section>
    </>
  );
};

export default EcoSection;
